/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a degenerate nucleotide motif written with IUPAC ambiguity codes into a regular expression. Paste the result into any regex-capable tool to search a DNA sequence for the motif.`)
};

const es_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un motivo de nucleótidos degenerado escrito con códigos de ambigüedad IUPAC en una expresión regular. Pega el resultado en cualquier herramienta compatible con regex para buscar el motivo en una secuencia de ADN.`)
};

const de_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie ein mit IUPAC-Mehrdeutigkeitscodes geschriebenes degeneriertes Nukleotidmotiv in einen regulären Ausdruck um. Fügen Sie das Ergebnis in jedes regex-fähige Tool ein, um eine DNA-Sequenz nach dem Motiv zu durchsuchen.`)
};

const nl_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een degeneratief nucleotidemotief geschreven met IUPAC-ambiguïteitscodes om naar een reguliere expressie. Plak het resultaat in elke regex-geschikte tool om een DNA-sequentie te doorzoeken op het motief.`)
};

const fr_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez un motif nucléotidique dégénéré écrit avec des codes d'ambiguïté IUPAC en une expression régulière. Collez le résultat dans n'importe quel outil compatible regex pour rechercher le motif dans une séquence d'ADN.`)
};

const it_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma un motivo nucleotidico degenerato scritto con codici di ambiguità IUPAC in un'espressione regolare. Incolla il risultato in qualsiasi strumento compatibile con le espressioni regolari per cercare il motivo in una sequenza di DNA.`)
};

const pt_br2_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme um motivo de nucleotídeos degenerado escrito com códigos de ambiguidade IUPAC em uma expressão regular. Cole o resultado em qualquer ferramenta compatível com regex para buscar o motivo em uma sequência de DNA.`)
};

const pt_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme um motivo de nucleótidos degenerado escrito com códigos de ambiguidade IUPAC numa expressão regular. Cole o resultado em qualquer ferramenta compatível com regex para pesquisar uma sequência de ADN pelo motivo.`)
};

const ja_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC縮重コードで書かれた縮重ヌクレオチドモチーフを正規表現に変換します。結果を正規表現に対応したツールに貼り付けて、DNA配列中のモチーフを検索できます。`)
};

const zh_iupac_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将使用 IUPAC 简并码书写的核苷酸模体转换为正则表达式。将结果粘贴到任何支持正则表达式的工具中，即可在 DNA 序列中搜索该模体。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_intro", locale)
	if (locale === "en") return en_iupac_intro(inputs)
	if (locale === "es") return es_iupac_intro(inputs)
	if (locale === "de") return de_iupac_intro(inputs)
	if (locale === "nl") return nl_iupac_intro(inputs)
	if (locale === "fr") return fr_iupac_intro(inputs)
	if (locale === "it") return it_iupac_intro(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_intro(inputs)
	if (locale === "pt") return pt_iupac_intro(inputs)
	if (locale === "ja") return ja_iupac_intro(inputs)
	return zh_iupac_intro(inputs)
};